module.exports = __webpack_public_path__ + "img/qianyan-logo.43213144.png";